<app-price
  [price]="total"
  [currency]="currency"
  size="xl"
  spacing="lg"
></app-price>
